import { helper } from '@ember/component/helper';
import { v4 } from 'ember-uuid';

const uuid = () => v4();

export default helper(uuid);
